/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Source_InheritedInputs */



/**
* | output |
* | --- |
* | "Everyone value shown — team grants or floors are not included; effective access can differ." |
*
* @param {Rights_Tools_Source_InheritedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_source_inherited = /** @type {((inputs?: Rights_Tools_Source_InheritedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Source_InheritedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wird der Wert für „Alle“ angezeigt – Team-Gewährungen oder -Sperren sind nicht berücksichtigt; der effektive Zugriff kann abweichen.")
	return /** @type {LocalizedString} */ ("Everyone value shown — team grants or floors are not included; effective access can differ.")
});